import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchTaskTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'task_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveTaskType(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let taskTypeData = {
    doc_type: DocType.TASK_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: taskTypeData,
    user,
  });

}

export function deleteTaskType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.TASK_TYPE
  });
}

export function fetchTaskTypeById(app, params) {
  const { id } = params;
  const docType = DocType.TASK_TYPE;
  return common.getDoc(app, { id, docType });
}
